// An alternative to using Boolean, this utility function actually narrows the type (and doesn't accidentally filter
// out defined-but-falsey values like 0).
export function isDefined(value) {
    return value !== null && value !== undefined;
}
